module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_9016.2e69e062.png";